import styled from "styled-components"

export const Header = styled.div`
  margin: -20px -20px 20px;
  padding: 20px;
  border-bottom: 1px solid var(--border-subtle);
`

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
`

export const Subtitle = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--text-muted);
`

export const FieldsRow = styled.div`
  display: flex;
  gap: 16px;

  > * {
    flex: 1;
    min-width: 0;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 0;
  }
`

// SelectDynamic has no bottom margin of its own, unlike the inputs
export const SelectsRow = styled(FieldsRow)`
  margin-bottom: 16px;

  @media (max-width: 500px) {
    gap: 16px;
  }
`

export const StepperLabel = styled.div`
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
`

export const InfoBanner = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0 4px;
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--surface-3);
  font-size: 13px;
  line-height: 20px;
  color: var(--text-secondary);

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-top: 2px;
  }
`
